export class ThemeStatus
{
    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);

            this.setParameters(json);
        }
    }

    public CurrentThemeTime: Date;
    public IsGatewayOnline: boolean;
    public IsThemeForcedOff: boolean;
    public IsThemeForcedOn: boolean;
    public IsThemeOffDueToForceOnExpiration: boolean;
    public IsThemeOn: boolean;
    public IsThemeScheduledOn: boolean;
    public LastGatewayCommunication: Date;
    public LastThemeForceOffTime: Date;
    public LastThemeForceOnTime: Date;
    public LastScheduledOffTime: Date;
    public LastScheduledOnTime: Date;
    public NextScheduledOffTime: Date;
    public NextScheduledOnTime: Date;
    public ThemeDstOffset: number;
    public ThemeId: number;
    public TroubleshootingInfo: string;
    public WhenThemeForceReleased: Date;
    public StatusText: string;
    public NextStatusText: string;

    private setParameters(json: object)
    {
        this.CurrentThemeTime = new Date(json['CurrentThemeTime']);
        this.LastGatewayCommunication = new Date(json['LastGatewayCommunication']);
        this.LastThemeForceOffTime = new Date(json['LastThemeForceOffTime']);
        this.LastThemeForceOnTime = new Date(json['LastThemeForceOnTime']);
        this.LastScheduledOffTime = new Date(json['LastScheduledOffTime']);
        this.LastScheduledOnTime = new Date(json['LastScheduledOnTime']);
        this.NextScheduledOffTime = new Date(json['NextScheduledOffTime']);
        this.NextScheduledOnTime = new Date(json['NextScheduledOnTime']);
        this.WhenThemeForceReleased = new Date(json['WhenThemeForceReleased']);
    }
}
